module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kb-La.57ce3d62.png";